

<template>

    <div :class=" headerClasses " :style="{ bottom : this.topHeaderOpen ? '-25px' : '0px' }">
        <p :class=" topHeaderAppTitleClass ">Express Orders</p>
        <p :class=" topHeaderMerchantNameClass ">{{ currentMerchant.name }}</p>
        <!--<p class="top-header-subtitle">A healthy way to start off your day</p>-->

        <button type="button" :class=" buttonClass " @click=" redirectMenu() ">START ORDER</button>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'top-head',
        computed: {

            ...mapGetters({

                topHeaderOpen   : 'nav/topHeaderOpen',
                isAuth          : 'auth/isAuth',
                currentMerchant : 'merchant/currentMerchant',
                merchantSlug    : 'merchant/merchantSlug',
                currentLocation : 'merchant/currentLocation',
                merchantIdCrocante  : 'merchantIdCrocante',
            }),
            headerClasses: function(){

                if (this.topHeaderOpen) {
                    const base = [ 'header-base-class', 'inner-wrap' ];
                    return base.join( ' ' );
                } else {
                    const base = [ 'header-base-class', 'inner-wrap-open' ];
                    return base.join( ' ' );
                }

            },
            topHeaderAppTitleClass() {
                const base = [ 'top-header-app-title' ];
                base.push( this.currentMerchant.merchantId == this.merchantIdCrocante ? 'crocante-title' : 'xo-title' )
                return base.join( ' ' );
            },
            topHeaderMerchantNameClass() {
                const base = [ 'top-header-merchant-name' ];
                base.push( this.currentMerchant.merchantId == this.merchantIdCrocante ? 'crocante-title' : 'xo-title' )
                return base.join( ' ' );
            },
            buttonClass() {

                const base = [ 'button' ];
                base.push( this.currentMerchant.merchantId == this.merchantIdCrocante ? 'btn-brown crocante-color-font' : 'btn-white' )
                return base.join( ' ' );
            }
        },
        methods: {

            redirectMenu(){
                    this.$router.replace({ 
                        name: 'merchant-location'
                    });
                // this.$router.push({

                //     name: 'order-menu',
                //     params : { slug: this.merchantSlug }
                // });
            }
        }
    }

</script>

<style scoped>

    .header-base-class {

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;

        position: relative;
        width: 100%;
        /*height: 125px;*/
        transition: all 0.7s;
    }
    .inner-wrap {

        padding-left: 15px;
        position: relative;
    }
    .inner-wrap-open {

        height: 125px;
        padding-left: 15px;
        position: relative;
    }
    .top-header-app-title {

        font-size: 16px;
        padding-bottom: 10px;
    }

    .crocante-title {
        color: #4A2612;
    }

    .xo-title {
        color: #fff;
    }
    .top-header-merchant-name {

        font-size: 28px;
    }

    .crocante-color-font {
        color: #fff;
    }

    .top-header-subtitle {

        font-size: 18px;
        width: 200px;
        color: rgb(141, 212, 124);
    }

    button {

        margin: 20px 0px 0px !important;
        border-radius: 15px;
        border: none;
        font-weight: bold;
    }

    .header-open {

        top: 0;
    }
    .header-close {

        top: -125px;
    }
</style>